<template>
    <div>
      <div class="row">
        <div class="col-md-12">
          <div class="top-list-toolbar">
            <div>
              <h4 class="text-primary" @click="backParent">Convert</h4>
              <ol class="breadcrumb breadcrumb-card-header">
                <li class="breadcrumb-item">
                  <a href="javascript:void(0);" @click="backParent">Convert</a>
                </li>
                <li class="breadcrumb-item active">
                  <span v-if="convert.id === null">New</span>
                  <span v-else>
                    {{ convert.convert_no }}
                  </span>
                </li>
              </ol>
              <button class="btn btn-success btn-sm pull-left dropdown-toggle" type="button" id="printsales" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" v-show="convert.conver_no !== null">Action</button>
              <div class="dropdown-menu" aria-labelledby="printsales">
                <a class="dropdown-item" href="javascript:void(0)" @click="syncCOGS('reply')">Sync COGS</a>
                <a class="dropdown-item" href="javascript:void(0)" @click="setJournal('reply')">Set Journal</a>
                <a class="dropdown-item" href="javascript:void(0)" @click="removeConvert" v-if="authUser.permissions.convert_delete">Delete</a>
              </div>
              <button type="button" @click="updateConvert" class="btn btn-sm btn-soft-primary pull-left" v-show="convert.id !== null"><i class="fa fa-check" aria-hidden="true"></i> Update</button>
              <button type="button" @click="createConvert" class="btn btn-sm btn-soft-primary pull-left" v-show="convert.id == null && getTotal === 0"><i class="fa fa-check" aria-hidden="true"></i> Create</button>
              <button type="button" @click="validate" class="btn btn-sm btn-soft-primary pull-left">Validate</button>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <!-- card1 -->
        <div :class="card1">
          <div class="card card-list">
            <div class="card-header">
              <div class="col-md-12">
                <h5 class="text-primary">
                  <span v-if="convert.id === null">New</span>
                  <span v-else>{{ convert.convert_no }}</span>
                  <span class="badge badge-primary ml-1">{{ convert.status }}</span>
                </h5>
              </div>
            </div>
            <div class="card-body">
              <div class="alert alert-danger alert-dismissible fade show" role="alert" v-if="alert.length > 0">
                <ul v-for="(a, index) in alert" :key="index">
                  <li v-html="a"></li>
                </ul>
              </div>
              <div class="row">
                  <div class="col-md-6">
                    <dl class="row dl-custom font-12">
                      <dt class="col-md-4">Convert No.</dt>
                      <dd class="col-md-8">
                        <input type="text" class="form-control form-control-lite" v-model="convert.convert_no" disabled/>
                      </dd>

                      <dt class="col-md-4">Tanggal</dt>
                      <dd class="col-md-8">
                        <datetime v-model="convert.convert_date" format="dd/MM/yyyy" class="form-control form-control-lite" value-zone="local" zone="local" @input="checkDate"></datetime>
                      </dd>

                      <dt class="col-md-4">Warehouse</dt>
                      <dd class="col-md-8">
                        <select v-model="convert.warehouse_no" class="form-control">
                          <option v-for="u in warehouseList" :key="u.id" :value="u.warehouse_no">{{ u.name }}</option>
                        </select>
                      </dd>
                    </dl>
                  </div>
                  <div class="col-md-6">
                    <dl class="row dl-custom font-12">
                      <dt class="col-md-2">Product No.</dt>
                      <dd class="col-md-8">
                        <v-select :options="productselect" :reduce="product => product.meta.code" label="product" v-model="convert.product_no" @input="setCProduct"/>
                      </dd>
                      <dd class="col-md-2">
                        <button class="btn btn-primary btn-sm" @click="setCost"><i class="fa fa-refresh"></i> Get Cost</button>
                      </dd>
                      <table class="table table-sm table-item table-hover table-striped">
                        <thead>
                          <th style="width: 20%;" class="text-center">Satuan</th>
                          <th style="width: 20%;" class="text-center">Qty</th>
                          <th style="width: 20%;" class="text-center">UoM</th>
                          <th style="width: 20%;" class="text-right">Cost (Per Item)</th>
                          <th style="width: 20%;" class="text-right">Total</th>
                        </thead>
                        <tbody>
                          <tr>
                            <th class="text-center">Pertama</th>
                            <td><input type="text" class="form-control" v-model="convert.qty" @keyup="setRatioCProduct()"/></td>
                            <td>
                              <select v-model="convert.uom_id" class="form-control" @change="setRatioCProduct()" disabled>
                                <option v-for="u in convert.uoms" :key="u.id" :value="u.uom_id">{{ u.uom_id }}</option>
                              </select>
                            </td>
                            <td class="text-right">Rp. {{ convert.cost | currency }}</td>
                            <td class="text-right">Rp. {{ getBefore | currency }}</td>
                          </tr>
                          <tr>
                            <th class="text-center">Kedua</th>
                            <td><input type="text" class="form-control" v-model="convert.qty_total" @keyup="setRatioCProduct()" disabled/></td>
                            <td>
                              <select v-model="convert.uom_total" class="form-control" @change="setRatioCProduct()" disabled>
                                <option v-for="u in convert.uoms" :key="u.id" :value="u.uom_id">{{ u.uom_id }}</option>
                              </select>
                            </td>
                            <td class="text-right">Rp. {{ convert.cost_total | currency }}</td>
                            <td class="text-right">Rp. {{ getAfter | currency }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </dl>
                  </div>
              </div>
              <hr>
              <div class="row">
                <div class="col-md-12">
                  <ul class="nav nav-tabs nav-bordered">
                    <li class="nav-item"><a href="#convert" data-toggle="tab" aria-expanded="false" class="nav-link active">Convert Product</a></li>
                    <li class="nav-item"><a href="#journal" data-toggle="tab" aria-expanded="false" class="nav-link">Journal</a></li>
                  </ul>
                  <div class="tab-content">
                      <div class="tab-pane active" id="convert">
                        <table class="table table-sm table-item table-hover table-striped">
                          <thead>
                            <th style="width: 25%">Product</th>
                            <th>Warehouse</th>
                            <th style="width: 10%">Qty</th>
                            <th>UoM</th>
                            <!-- <th style="width: 10%">Qty Convert</th>
                            <th>Uom</th> -->
                            <th style="width: 10%">Total</th>
                            <th>UoM Total</th>
                            <th class="text-right">Price (Per Item)</th>
                            <th class="text-right">Total</th>
                            <th class="text-center">#</th>
                          </thead>
                          <tbody>
                              <tr v-for="(d, index) in convertDetail" :key="d.id" >
                                <td>
                                  <v-select :options="productselect" :reduce="product => product.meta.code" label="product" v-model="d.product_no" @input="setProduct(index)"/>
                                </td>
                                <td>
                                  <select v-model="d.warehouse_no" class="form-control form-control-lite">
                                    <option v-for="u in warehouseList" :key="u.id" :value="u.warehouse_no">{{ u.name }}</option>
                                  </select>
                                </td>
                                <!-- <td>
                                    <input class="form-control" type="text" id="qty_stock" v-model="d.qty_stock" @keyup="calcRow(index)"/>
                                </td>
                                <td>
                                    <select v-model="d.uom_stock" class="form-control form-control-lite">
                                    <option v-for="u in uomList" :key="u.id" :value="u.id">{{ u.name }}</option>
                                  </select>
                                </td> -->
                                <td class="text-right">
                                    <input class="form-control" type="text" id="qty" v-model="d.qty" @keyup="calcRow(index)"/>
                                </td>
                                <td>
                                  <select v-model="d.uom_id" class="form-control" disabled>
                                    <option v-for="u in d.uoms" :key="u.id" :value="u.uom_id">{{ u.uom_id }}</option>
                                  </select>
                                </td>
                                <td class="text-right">
                                    <input class="form-control" type="text" id="qty_total" v-model="d.qty_total" disabled/>
                                </td>
                                <td>
                                  <select v-model="d.uom_total" class="form-control form-control-lite" disabled>
                                    <option v-for="u in d.uoms" :key="u.id" :value="u.uom_id">{{ u.uom_id }}</option>
                                  </select>
                                </td>
                                <td class="text-right">
                                  {{ d.cost | currency }}
                                  <!-- <input class="form-control" type="text" id="cost" v-model="d.cost"/> -->
                                </td>
                                <td class="text-right">
                                  {{ d.cost_total | currency }}
                                  <!-- <input class="form-control" type="text" id="cost_total" v-model="d.cost_total" disabled/> -->
                                </td>
                                <td class="text-center">
                                  <button type="button" class="btn btn-sm btn-soft-outline-danger" @click="removeDetail(index)"><i class="fa fa-trash" aria-hidden="true"></i></button>
                                </td>
                              </tr>
                              <tr>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td class="text-right" v-if="getTotal === 0">
                                  <i class="fa fa-check"></i>
                                </td>
                                <td class="text-right" v-else>
                                  {{ getTotal | currency }}
                                </td>
                                <td></td>
                                <td></td>
                                <td class="text-right" v-if="getTotal === 0">
                                  <i class="fa fa-check"></i> Rp. {{ getBefore | currency }}
                                </td>
                                <td class="text-right" v-else>
                                  Rp. {{ getTotalCost | currency }}
                                </td>
                                <td></td>
                              </tr>
                              <tr>
                                <td><span @click="addNewLine" class="link-secondary" v-show="getTotal > 0">+ Add Product</span></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                              </tr>
                          </tbody>
                          <tfoot>
                          </tfoot>
                        </table>
                      </div>
                      <div class="tab-pane" id="journal">
                        <div class="table-responsive">
                          <table class="table table-sm table-item table-hover table-striped">
                            <thead>
                              <th>Journal Code</th>
                              <th>Date</th>
                              <th>Account Code</th>
                              <th>Remark</th>
                              <th class="text-right">Debit</th>
                              <th class="text-right">Credit</th>
                            </thead>
                            <tbody>
                              <tr v-for="j in convert.journals" :key="j.id">
                                <td>
                                  <span v-if="j.level === 1">
                                    <b>{{ j.journal_code }} - {{ j.journal_description }}</b>&nbsp;
                                    <span class="badge badge-success" v-if="j.status === 'posted'">{{ j.status }}</span>
                                    <span class="badge badge-warning" v-else-if="j.status === 'draft'">{{ j.status }}</span>
                                  </span>
                                  <span v-else></span>
                                </td>
                                <td>{{ j.journal_date | dateFormat('DD/MM/YYYY') }}</td>
                                <td><b>{{ j.account_code }} {{ j.account }}</b></td>
                                <td>{{ j.remark }}</td>
                                <td class="text-right">
                                  <span v-if="j.level === 2">{{ j.debit | currency }}</span>
                                  <span v-if="j.level === 3"><b>{{ j.debit | currency }}</b></span>
                                  <span v-else></span>
                                </td>
                                <td class="text-right">
                                  <span v-if="j.level === 2">{{ j.credit | currency }}</span>
                                  <span v-if="j.level === 3"><b>{{ j.credit | currency }}</b></span>
                                  <span v-else></span>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                          <!-- <button type="button" class="btn btn-sm btn-success pull-right" @click="postJournal">Post</button> -->
                        </div>
                      </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-footer">
            </div>
          </div>
        </div>
      </div>
      <div class="row justify-content-md-center">
        <div class="col-md-6">
          <h5>Logs:</h5>
          <div class="alert alert-info" role="alert" v-for="l in convert.logs" :key="l.id">
            <b>{{ l.user }}</b> - {{ l.log_date | dateFormat('DD/MM/YYYY HH:mm:ss') }} <span>"{{ l.description }}"</span>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import { convertUrl, productUrl, setQtyTotalUrl, getHeader } from '../../config'

export default {
  name: 'ConvertForm',
  props: ['convert', 'convert2'],
  components: {
    //
  },
  data () {
    return {
      alert: [],
      inventoryData: {},
      uomList: [],
      costTotal: 0,
      selectQty: false,
      searchQueryInventory: '',
      searchQueryOrder: '',
      card1: 'col-md-12',
      card2: null,
      ref: null,
      refNo: null,
      idDetail: null,
      detail: null,
      quantity: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: true /* doesn't work with directive */
      },
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: true /* doesn't work with directive */
      }
    }
  },
  created () {
    this.ref = this.$route.query.ref
    this.refNo = this.$route.query.refNo
  },
  computed: {
    ...mapState({
      authUser: state => state.users.authUser,
      brachList: state => state.branches.branchList,
      productListAll: state => state.products.productListAll,
      productListSelect: state => state.products.productListSelect,
      warehouseList: state => state.warehouses.warehouseList
    }),
    productselect: function () {
      var loop = []
      var array = this.productListAll
      for (var x = 0; x < array.length; x++) {
        var obj = {
          product: array[x].product_no + ' - ' + array[x].product_name,
          meta: {
            code: array[x].product_no
          }
        }
        loop.push(obj)
      }
      return loop
    },
    getBefore () {
      var total = parseFloat(this.convert.qty) * parseFloat(this.convert.cost)
      return total
    },
    getAfter () {
      var total = parseFloat(this.convert.qty_total) * parseFloat(this.convert.cost_total)
      return total
    },
    convertDetail: function () {
      return this.convert.details.filter(d => d.id !== null)
    },
    getTotal () {
      var qty = 0
      var sum = 0
      var total = 0
      var array = this.convert.details
      var uom = this.convert.uoms.find(d => d.uom_id === this.convert.uom_id)
      var ratio = 0
      if (uom) {
        ratio = uom.ratio
        console.log(uom)
        if (uom.category_id === 1) {
          qty = parseFloat(this.convert.qty_total) * parseFloat(ratio)
        } else if (uom.category_id === 2) {
          qty = parseFloat(this.convert.qty_total) / parseFloat(ratio)
        } else {
          qty = parseFloat(this.convert.qty_total)
        }
        for (let i = 0; i < array.length; i++) {
          sum += parseFloat(array[i].qty_total)
        }
      } else {
        ratio = 0
        qty = 0
        sum = 0
      }
      console.log(qty.toFixed(2) + ' - ' + sum.toFixed(2))
      total = qty.toFixed(2) - sum.toFixed(2)
      return total
    },
    getTotalCost () {
      var cost = this.convert.cost_total === null ? 0 : this.convert.cost_total
      var qty = 0
      var sum = 0
      var total = 0
      var costTotal = 0
      var array = this.convert.details
      var uom = this.convert.uoms.find(d => d.uom_id === this.convert.uom_id)
      var ratio = 0
      if (uom) {
        ratio = uom.ratio
        if (uom.category_id === 1) {
          qty = parseFloat(this.convert.qty_total) * parseFloat(ratio)
        } else if (uom.category_id === 2) {
          qty = parseFloat(this.convert.qty_total) / parseFloat(ratio)
        } else {
          qty = parseFloat(this.convert.qty_total)
        }
        for (let i = 0; i < array.length; i++) {
          sum += parseFloat(array[i].cost_total)
        }
      } else {
        ratio = 0
        qty = 0
        sum = 0
      }
      costTotal = parseFloat(cost) * parseFloat(qty)
      total = parseFloat(costTotal) - parseFloat(sum)
      return parseFloat(total)
    }
  },
  methods: {
    async removeConvert () {
      await this.$swal.fire({
        title: 'Are you sure Delete this?',
        text: "You won't be able to revert this!",
        icon: 'error',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.value) {
          axios.delete(convertUrl + '/' + this.convert.id, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
            .then(response => {
              console.log(response.data.message)
            })
            .catch(error => {
              console.log(error)
              console.log(error.response)
              this.$swal('Error', error.response.data.message, 'error')
              throw error
            })
        }
      })
      this.alert = []
      await this.syncCOGS('no reply')
      await this.$swal('Success', 'Success Delete Convert', 'success')
      await this.$emit('backSaveChild')
    },
    async checkDate () {
      var date1 = new Date()
      date1.setHours(0, 0, 0, 0)
      var date2 = new Date(this.convert.convert_date)
      date2.setHours(0, 0, 0, 0)
      var remaining = date2.getTime() - date1.getTime()
      var diffInDay = remaining / (1000 * 3600 * 24)
      console.log('Diff in a day ' + diffInDay)
      if (diffInDay > 0) {
        this.$swal('Error', 'Tanggal tidak boleh lebih dari hari ini (' + diffInDay + ' hari)', 'error')
        this.convert.convert_date = date1.toISOString()
      } else if (Math.abs(diffInDay) > 2) {
        this.$swal('Error', 'Tanggal tidak boleh kurang dari 2 hari', 'error')
        this.convert.convert_date = date1.toISOString()
      }
    },
    async validate () {
      this.alert = []
      if (this.convert.product_no === null) {
        this.alert.push('<b>Product</b> harus diinput terlebih dahulu')
      }
      var qtyConvert = parseFloat(this.convert.qty)
      var qtyExist = parseFloat(this.convert2.qty)
      var product = this.productListAll.find(d => d.product_no === this.convert.product_no)
      var productName = product ? product.product_name : null
      var obj = {
        product_no: this.convert.product_no,
        date: this.convert.convert_date
      }
      var url = productUrl + '/cost/get-saldo'
      console.log(obj)
      console.log(url)
      await axios.post(url, obj, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          console.log(response.data.message)
          const stockQty = parseFloat(response.data.data.qty)
          var qtySaldo = stockQty + qtyExist
          console.log('Qty Saldo:' + qtySaldo)
          if (qtySaldo === 0) {
            this.alert.push('<strong>[' + this.convert.product_no + '] ' + productName + '</strong> ' + ' Saldo stock kurang = ' + stockQty)
          } else {
            console.log('Remaining ' + this.convert.product_no + ' ' + stockQty + '+ ' + qtyExist + ' = ' + qtySaldo)
            var qtyRemaining = qtySaldo - qtyConvert
            if (qtyRemaining < 0) {
              this.alert.push('<strong>[' + this.convert.product_no + '] ' + productName + '</strong> ' + ' Saldo stock kurang = ' + qtySaldo)
            }
          }
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
        })
    },
    async setJournal (reply) {
      var obj = {
        id: this.convert.id
      }
      var resp = {
        error: false,
        message: null
      }
      await axios.post(convertUrl + '/journal', obj, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          resp.error = false
          resp.message = response.data.message
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
      if (reply === 'reply') {
        if (resp.error === false) {
          this.$swal('Success', resp.message, 'success')
        } else {
          this.$swal('Error', resp.message, 'error')
        }
      }
    },
    async syncCOGS (reply) {
      // convert out
      var data = {
        product_no: this.convert.product_no,
        date: this.convert.convert_date,
        type: 'all',
        company_no: this.convert.company_no
      }
      var resp = {
        error: false,
        message: null
      }
      console.log('origin')
      console.log(data)
      console.log(productUrl + '/cost/sync')
      await axios.post(productUrl + '/cost/sync', data, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          console.log(response.data.message)
          resp.error = false
          resp.message = response.data.message
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
      var array = this.convert.details
      for (let i = 0; i < array.length; i++) {
        var data2 = {
          product_no: array[i].product_no,
          date: this.convert.convert_date,
          type: 'all',
          company_no: this.convert.company_no
        }
        console.log('after:')
        console.log(data2)
        console.log(productUrl + '/cost/sync')
        await axios.post(productUrl + '/cost/sync', data2, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
          .then(response => {
            console.log(response.data.message)
            resp.error = false
            resp.message = response.data.message
          })
          .catch(error => {
            console.log(error)
            console.log(error.response)
            this.$swal('Error', error.response.data.message, 'error')
          })
      }
      if (reply === 'reply') {
        if (resp.error === false) {
          await this.$swal('Success', resp.message, 'success')
        }
      }
    },
    setRatioCProduct () {
      var cQty = this.convert.qty.toString().replace(/\./g, '').replace(/,/g, '.')
      var cCost = this.convert.cost
      var qty = 0
      var cost = 0
      // var uom = null
      var ratio = 0
      var getUom = this.convert.uoms.find(d => d.category_id === 1)
      if (getUom) {
        ratio = getUom.ratio
        qty = parseFloat(cQty) * parseFloat(ratio)
        cost = parseFloat(cCost) / parseFloat(ratio)
      } else {
        // uom = this.convert.uoms.find(d => d.uom_id === this.convert.uom_id)
        qty = parseFloat(cQty)
        cost = parseFloat(cCost)
      }
      this.convert.qty_total = qty
      this.convert.cost_total = cost
      console.log(cCost)
      var array = this.convert.details
      for (let i = 0; i < array.length; i++) {
        this.calcRow(i)
      }
    },
    async setCProduct () {
      const valid = this.validate()
      if (valid === false) {
        return false
      }
      const auth = JSON.parse(window.localStorage.getItem('authUser'))
      var company = auth.user.company_no
      var product = this.productListAll.find(p => p.product_no === this.convert.product_no)
      console.log(productUrl + '/uom/' + this.convert.product_no)
      await axios.get(productUrl + '/uom/' + this.convert.product_no, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          var uoms = response.data.data
          this.convert.uoms = uoms
          var getUom = this.convert.uoms.find(d => d.category_id === 1)
          var defUom = this.convert.uoms.find(d => d.category_id === 3)
          if (getUom) {
            this.convert.uom_total = getUom.uom_id
          } else {
            this.convert.uom_total = defUom.uom_id
            this.$swal('Error', 'Item tidak memiliki satuan pembanding atau satuan terkecil. Silahkan tambahkan satuan pada item terlebih dahulu.', 'error')
          }
        })
        .catch(error => {
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
      var data = {
        date: this.convert.convert_date,
        product_no: this.convert.product_no,
        company: company
      }
      await axios.post(productUrl + '/cost/product', data, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          var array = response.data.data[0]
          var cost = 0
          if (array) {
            cost = array.cost_average === null ? 0 : array.cost_average
          }
          this.convert.cost = parseFloat(cost).toString().replace(/\./g, ',')
        })
        .catch(error => {
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
      this.convert.uom_id = product.uom_id
    },
    async setCost () {
      var data = {
        ref_no: this.convert.convert_no,
        notes: null,
        product_no: this.convert.product_no
      }
      await axios.post(productUrl + '/cost/product-by-ref-no', data, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          console.log('cost by ref no: ' + response.data.data)
          var totalCOST = response.data.data
          var price = parseFloat(totalCOST) / parseFloat(this.convert.qty)
          this.convert.cost = price
        })
        .catch(error => {
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })

      this.setRatioCProduct()
      var array = this.convert.details
      var count = array.length
      for (let i = 0; i < count; i++) {
        this.calcRow(i)
      }
    },
    async setProduct (index) {
      var no = 0
      if (this.convert.details[0].id === null) {
        no = index + 1
      } else {
        no = index
      }
      this.convert.details[no].uom_total = this.convert.uom_total
      await axios.get(productUrl + '/uom/' + this.convert.details[no].product_no, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          var uoms = response.data.data
          var ut = uoms.find(u => u.category_id === 1)
          var ud = uoms.find(u => u.category_id === 3)
          if (ut) {
            this.convert.details[no].uom_stock = ut.uom_id
            this.convert.details[no].uom_id = ud.uom_id
            this.convert.details[no].uom_total = ut.uom_id
          } else if (ud) {
            this.$swal('Error', 'Item tidak memiliki satuan pembanding atau satuan terkecil. Silahkan tambahkan satuan pada item terlebih dahulu.', 'error')
            this.convert.details[no].uom_stock = ud.uom_id
            this.convert.details[no].uom_id = ud.uom_id
            this.convert.details[no].uom_total = ud.uom_id
          } else {
            this.$swal('Error', 'Item tidak memiliki satuan pembanding atau satuan terkecil. Silahkan tambahkan satuan pada item terlebih dahulu.', 'error')
            this.convert.details[no].uom_stock = this.convert.uom_id
            this.convert.details[no].uom_id = this.convert.uom_id
            this.convert.details[no].uom_total = this.convert.uom_id
          }
          this.convert.details[no].uoms = uoms
        })
        .catch(error => {
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
    },
    backParent: function () {
      this.alert = []
      this.$emit('backClicked')
    },
    async updateConvert () {
      this.validate()
      if (this.alert.length > 0) {
        this.$swal('Error', 'Data Convert tidak valid, cek terlebih dahulu', 'error')
        return false
      }
      this.setRatioCProduct()
      var array = this.convert.details
      var count = array.length
      for (let i = 0; i < count; i++) {
        this.calcRow(i)
      }
      await axios.put(convertUrl + '/' + this.convert.id, this.convert, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.setQtyTotal(this.convert.product_no)
          var array = this.convert.details
          console.log(array)
          for (let i = 0; i < array.length; i++) {
            var code = array[i].product_no
            if (code !== null) {
              this.setQtyTotal(code)
            }
            this.setQtyTotal(code)
          }
        })
        .catch(error => {
          console.log(error.response)
          this.$swal('Error!!', '', 'error')
        })
      await this.syncCOGS('no reply')
      await this.setJournal('no reply')
      await this.$swal('Convert', 'Success update convert', 'success')
      await this.$emit('backSaveChild')
    },
    async createConvert () {
      this.validate()
      if (this.alert.length > 0) {
        this.$swal('Error', 'Data Convert tidak valid, cek terlebih dahulu', 'error')
        return false
      }
      this.setRatioCProduct()
      var array = this.convert.details
      var count = array.length
      for (let i = 0; i < count; i++) {
        this.calcRow(i)
      }
      var convertID = null
      await axios.post(convertUrl, this.convert, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          convertID = response.data.data.id
          this.setQtyTotal(this.convert.product_no)
          var array = this.convert.details
          console.log(array)
          for (let i = 0; i < array.length; i++) {
            var code = array[i].product_no
            if (code !== null) {
              this.setQtyTotal(code)
            }
          }
          this.convert = response.data.data
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Error!!', error.response.data.message, 'error')
        })
      await this.$emit('backParentID', convertID)
      await this.$swal('Convert', 'Process HPP', 'success')
      await this.syncCOGS('no reply')
      await this.setCost()
      await axios.put(convertUrl + '/' + this.convert.id, this.convert, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.setQtyTotal(this.convert.product_no)
          var array = this.convert.details
          for (let i = 0; i < array.length; i++) {
            var code = array[i].product_no
            if (code !== null) {
              this.setQtyTotal(code)
            }
            this.setQtyTotal(code)
          }
        })
        .catch(error => {
          console.log(error.response)
          this.$swal('Error!!', error.response.data.message, 'error')
        })
      await this.syncCOGS('no reply')
      await this.setJournal('no reply')
      await this.$swal('Convert', 'Success create convert', 'success')
      await this.$emit('backSaveChild')
    },
    async setQtyTotal (code) {
      var d = new Date()
      var n = d.getFullYear()
      var n1 = n - 1
      this.year = [n1, n]
      var newYear = d.getFullYear()
      var newMonth = d.getMonth() + 1
      var newDate = d.getDate()
      var newSetDate = newYear + '-' + newMonth + '-' + newDate
      var comNo = this.convert.company_no

      await axios.get(setQtyTotalUrl + '?end=' + newSetDate + '&available=true&company_no=' + comNo + '&product_no=' + code, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          console.log(response.data.message)
        })
        .catch(error => {
          this.$swal(
            'Error',
            error.response.data.message,
            'error'
          )
        })
    },
    addNewLine: function () {
      this.convert.details.push({
        convert_no: null,
        convert_date: null,
        product_no: null,
        qty_stock: 0,
        uom_stock: null,
        qty: 0,
        uom_id: null,
        uoms: [],
        qty_total: 0,
        uom_total: null,
        cost: 0,
        cost_total: 0,
        type: null,
        branch_no: null,
        company_no: this.convert.company_no,
        warehouse_no: this.convert.warehouse_no
      })
      this.state = 'create'
    },
    editDetail: function (id) {
      // var p = this.convert.details.find(d => d.id === id)
      this.idDetail = id
    },
    async removeDetail (index) {
      var no = 0
      if (this.convert.details[0].id === null) {
        no = index + 1
      } else {
        no = index
      }
      var detail = this.convert.details[no]
      if (typeof detail.id === 'undefined') {
        this.convert.details.splice(no, 1)
      } else {
        await this.$swal.fire({
          title: 'Are you sure Delete this?',
          text: "You won't be able to revert this!",
          icon: 'error',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
          if (result.value) {
            axios.delete(convertUrl + '/detail/' + detail.id, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
              .then(response => {
                this.convert.details.splice(no, 1)
              })
              .catch(error => {
                console.log(error.response)
              })
          }
        })
      }
    },
    calcRow (index) {
      var no = 0
      if (this.convert.details[0].id === null) {
        no = index + 1
      } else {
        no = index
      }
      var detail = this.convert.details[no]
      if (detail) {
        var uom = detail.uoms.find(d => d.category_id === 1)
        var ratio = uom ? uom.ratio : 0
        var cQty = detail.qty.toString().replace(/\./g, '').replace(/,/g, '.')
        var qty = 0
        if (uom.category_id === 1) {
          qty = parseFloat(cQty) * parseFloat(ratio)
        } else if (uom.category_id === 2) {
          qty = parseFloat(cQty) / parseFloat(ratio)
        } else {
          qty = parseFloat(cQty)
        }
        detail.qty_total = qty
        detail.cost = this.convert.cost_total * ratio
        detail.cost_total = detail.cost * detail.qty
      }
    }
  }
}
</script>

<style>
  .flex {
    display: flex;
    flex-direction: row;
  }
</style>
